@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.formControl {
  display: block;
  position: relative;
  margin-bottom: 16px;

  .error {
    @include core.font(core.$s, core.$regular, map.get(core.$fonts, error));
    height: auto;
    padding-top: 2px;
    text-align: left;
  }
}
